/* PDP Recipes 2026 — centered tiny-slider carousel.
   Same behavior as collection-slider-center (tns global from the header),
   scoped per section instance so multiple instances don't clash.
   The carousel minimum depends on the breakpoint: desktop needs
   MIN_SLIDER_DESKTOP (5) cards to fill the row (3 visible + edge bleed),
   while mobile (≤768px, a single visible card) only needs
   MIN_SLIDER_MOBILE (2). Below the minimum the section stays static and CSS
   centers the cards (.pdp-recipes-2026--static). The mode re-syncs on
   viewport resize (slider is built/destroyed when crossing the breakpoint)
   and on shopify:section:load so the theme editor picks up added/removed
   blocks. */
(function () {
  var MOBILE_BREAKPOINT = 768; /* must match the CSS media query */
  var MIN_SLIDER_DESKTOP = 5;
  var MIN_SLIDER_MOBILE = 2;

  function minSliderCount() {
    return window.innerWidth <= MOBILE_BREAKPOINT ? MIN_SLIDER_MOBILE : MIN_SLIDER_DESKTOP;
  }

  function destroySlider(root) {
    if (root.__pdprNav) {
      root.__pdprNav.remove();
      root.__pdprNav = null;
    }
    if (root.__pdprSlider) {
      root.__pdprSlider.destroy();
      root.__pdprSlider = null;
    }
  }

  function buildSlider(root, container, slideCount) {
    /* Whole items + symmetric edgePadding keep the middle card exactly
       centered (Figma: card 304 + gutter 36 on 1440 / card 258 + gutter 30
       on 393, neighbours peeking at both edges). */
    /* Arrows are opt-in (schema "show_arrows"): when the container isn't
       rendered, tell tns not to generate its default controls either. */
    var controlsEl = root.querySelector('.pdp-recipes-2026__controls');

    var slider = tns({
      container: container,
      items: 1,
      slideBy: 1,
      startIndex: 0,
      nav: false,
      controls: controlsEl ? true : false,
      controlsContainer: controlsEl || false,
      gutter: 30,
      edgePadding: 65,
      autoplay: false,
      loop: true,
      rewind: false,
      mouseDrag: true,
      touch: true,
      preventScrollOnTouch: 'force',
      swipeAngle: false,
      responsive: {
        480: { edgePadding: 85 },
        768: { items: 2, gutter: 32, edgePadding: 130 },
        1024: { items: 3, gutter: 36, edgePadding: 167 },
        1280: { items: 3, gutter: 36, edgePadding: 205 },
        1440: { items: 3, gutter: 36, edgePadding: 228 }
      }
    });
    root.__pdprSlider = slider;

    /* Custom dots, same pattern as collection-slider-center. When tns clones
       the slide list (loop mode), the pre-init slideCount keeps one dot per
       real recipe. */
    var dotsContainer = root.querySelector('.pdp-recipes-2026__dots');
    if (!dotsContainer || dotsContainer.getAttribute('data-show-nav') !== 'true') return;

    var navContainer = document.createElement('div');
    navContainer.className = 'tns-nav custom-nav';

    for (var i = 0; i < slideCount; i++) {
      var button = document.createElement('button');
      button.setAttribute('data-nav', i);
      button.setAttribute('aria-label', 'Slide ' + (i + 1));
      button.type = 'button';
      if (i === 0) button.classList.add('tns-nav-active');
      navContainer.appendChild(button);
    }

    dotsContainer.appendChild(navContainer);
    root.__pdprNav = navContainer;

    slider.events.on('indexChanged', function (info) {
      var realIndex = (info.displayIndex - 1) % slideCount;
      navContainer.querySelectorAll('button').forEach(function (btn, idx) {
        btn.classList.toggle('tns-nav-active', idx === realIndex);
      });
    });

    navContainer.addEventListener('click', function (e) {
      if (e.target.tagName === 'BUTTON') {
        slider.goTo(parseInt(e.target.getAttribute('data-nav'), 10));
      }
    });
  }

  function syncMode(root) {
    var container = root.querySelector('.pdp-recipes-2026__slider');
    if (!container) return;

    var sliding = !!root.__pdprSlider;
    /* With tns active the container holds loop clones, so the server-rendered
       data-real-count is the source of truth for the real card count. */
    var count = parseInt(root.getAttribute('data-real-count'), 10) || (sliding ? 0 : container.children.length);
    if (!count) return;

    var shouldSlide = count >= minSliderCount() && typeof tns !== 'undefined';

    if (shouldSlide && !sliding) {
      root.classList.remove('pdp-recipes-2026--static');
      buildSlider(root, container, count);
    } else if (!shouldSlide && sliding) {
      destroySlider(root);
      root.classList.add('pdp-recipes-2026--static');
    } else {
      root.classList.toggle('pdp-recipes-2026--static', !shouldSlide);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-pdp-recipes-slider]').forEach(syncMode);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  /* Crossing the mobile/desktop breakpoint changes the required minimum, so
     re-sync (build or destroy) after the viewport settles. */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initAll();
    }, 150);
  });

  /* Theme editor: re-init when the section is re-rendered (block added,
     removed or a setting changed). */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
